// AdminProvider.js
const serverUrl = "/api";
class AdminProvider {


        // Helper to get admin token from local storage
        _getAdminToken() {
            // Assuming the admin token is stored in localStorage after successful AuthLogin
            const adminToken = localStorage.getItem('admin_token'); 
            if (!adminToken) {
                console.error('Admin token not found. Admin actions are unauthorized.');
                throw new Error('Admin not authenticated.');
            }
            return adminToken;
        }

        async getAllGames(lang = 'en') {
            const adminToken = this._getAdminToken();
            try {
                const response = await fetch(serverUrl + `/admin/games?lang=${lang}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-admin-token': adminToken, // Pass admin token in a custom header
                    },
                });
                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.error || 'Failed to fetch games for admin');
                }
                return await response.json();
            } catch (error) {
                console.error('Error in AdminProvider.getAllGames:', error);
                throw error;
            }}

async getAllUsers() {
        const adminToken = this._getAdminToken();
        try {
            const response = await fetch(serverUrl + `/admin/users`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-admin-token': adminToken, // Pass admin token in a custom header
                },
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Failed to fetch users for admin');
            }
            return await response.json();
        } catch (error) {
            console.error('Error in AdminProvider.getAllUsers:', error);
            throw error;
        }}

        async createCoupon(couponData) {
            const adminToken = this._getAdminToken();
            try {
                const response = await fetch(serverUrl + `/admin/create-coupon`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-admin-token': adminToken, // Pass admin token in a custom header
                    },
                    body: JSON.stringify(couponData),
                });
                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.error || 'Failed to create coupon');
                }
                return await response.json();
            } catch (error) {
                console.error('Error in AdminProvider.createCoupon:', error);
                throw error;
            }
        }

        async getAllPlays(limit = 10, offset = 0) {
            const adminToken = this._getAdminToken();
            try {
                const response = await fetch(serverUrl + `/admin/plays?limit=${limit}&offset=${offset}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-admin-token': adminToken,
                    },
                });
                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.error || 'Failed to fetch plays for admin');
                }
                return await response.json();
            } catch (error) {
                console.error('Error in AdminProvider.getAllPlays:', error);
                throw error;
            }
        }

        async getAllSurveys(lang = 'en') {
            const adminToken = this._getAdminToken();
            try {
                const response = await fetch(serverUrl + `/admin/surveys?lang=${lang}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-admin-token': adminToken,
                    },
                });
                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.error || 'Failed to fetch surveys for admin');
                }
                return await response.json();
            } catch (error) {
                console.error('Error in AdminProvider.getAllSurveys:', error);
                throw error;
            }
        }
    
    async checkCredentials(username, pw) {
        try {
            console.log("checkCredentials2");
            const response = await fetch(serverUrl + '/checkCredentials', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    username: username,
                    password: pw,
                }),
            });
            console.log("response");
            console.log(response);

            if (response.ok) {
                console.log('Match: ', response.statusText);
                const data = await response.json();
                return data;
            } else {
                console.error('Server error:', response.statusText);
                return null;
            }
        } catch (error) {
            console.error('Fetch error:', error);
            return null;
        }
    }
    
   
}

export default AdminProvider;
